import React, { Component } from 'react';
import axios from 'axios';
import './Leaderboard.css';
import {Link as RouterLink} from 'react-router-dom' ; 
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { connect } from 'react-redux';
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';
import { Redirect } from 'react-router';

class Leaderboard extends Component {

    state = {
        leaderboard: [],
        contestName: "",
        count: 0
    }

    getLeaderboard = () => {
        if (this.props.match.params.contestId.includes('cf')) {
            axios.get('https://server.codeium.tech/codeforces/leaderboard?contest_id=' + this.props.match.params.contestId).then(res => {
                // console.log(res.data.msg);
                let rows = [];
                Object.values(res.data.msg).map((val) => {
                    rows.push(val);
                })
                // console.log(rows);
                this.setState({
                    leaderboard: rows
                })
            });
        } else {
            axios.post('https://server.codeium.tech/contest/' + this.props.match.params.contestId + '/leaderboard', {
                username: this.props.username,
                count: this.state.count
            }).then(res => {
                // console.log(res.data.msg);
                this.setState({
                    leaderboard: res.data.msg
                })
            })    
        }
    }

    componentDidUpdate(_, prevState) {
        if(this.state.count !== prevState.count) {
            this.getLeaderboard();
        } 
    }

    nextPage = () => {
        if(this.state.leaderboard === null || this.state.leaderboard.length === 0) {
            return;
        }
        this.setState(prevState => {
            return {
                count: prevState.count += 25
            }
        })
    }

    prevPage = () => {
        if(this.state.count === 0) {
            return;
        }
        this.setState(prevState => {
            return {
                count: prevState.count -= 25
            }
        })
    }

    componentDidMount() {
        // post request
        this.getLeaderboard();
        axios.post('https://server.codeium.tech/contest/name', {
            username: this.props.username,
            contest_id: this.props.match.params.contestId
        }).then(res => {
            this.setState({ 
                contestName: res.data.msg[0].contest_name
            })
            // console.log(this.props.match.params.contestId)
        })
        .catch(err => {
            // console.log(err);
        })
        
    }

    render() {
        try {
            return (
                <>
                    <Header />
                    <div className="container my-5">
                        <h1 className="primary-heading">{this.state.contestName}</h1>
                        <div className="row">
                            <div className="col-12">
                                <div className="tab-container Leaderboard p-3">
                                    <div className="row">
                                        <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb bg-transparent pb-1">
                                            <RouterLink to={"/contests"}>
                                            <li >
                                                <a class="Leader_links">Contests</a>
                                            </li>
                                            </RouterLink>
                                            { " >> "}
                                            <RouterLink to={"/contests/" + this.props.match.params.contestId + "/"}>
                                            <li>
                                            <a class="Leader_links">
                                                {this.state.contestName}
                                            </a>
                                            </li>
                                            </RouterLink>
                                            { " >> "}   
                                            <RouterLink to={"/contests/" + this.props.match.params.contestId + "/problems"}>
                                                {!this.props.match.params.contestId.includes('cf') && <li >
                                                    <a class="Leader_links">Problems</a>
                                                </li>}
                                            </RouterLink>
                                            { " >> "}
                                            <li class="breadcrumb-item active" aria-current="page" className="LeaderboardName">
                                                Leaderboard
                                            </li>
                                        </ol>
                                        </nav>
                                    </div>
                                    <h3 className="mt-2">Leaderboard </h3>
                                    {/* <hr className="bg-dark mt-0" /> */}
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <table className="table table-responsive-md table-md Problem_Table">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Username</th>
                                                        <th scope="col">
                                                        {!this.props.match.params.contestId.includes('cf') && 
                                                            ('Problems Solved')
                                                        }
                                                        </th>
                                                        {/* <th scope="col">Submission Time</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.leaderboard.map((user, index) => {
                                                            let styles = {};
                                                            if(this.props.username === user.username) {
                                                                styles = {
                                                                    backgroundColor: "#ddeeff"
                                                                }
                                                            }
                                                            return (
                                                                <tr style={styles}>
                                                                    <td>{((this.state.count/25) *25) +index + 1}</td>
                                                                    {this.props.match.params.contestId.includes('cf') ? 
                                                                    <td><a href={'https://codeforces.com/profile/' + user.referral_code} target='_blank'>{user.username}</a></td> : 
                                                                    <td>{user.username}</td>
                                                                    }
                                                                    <td>{user.count}</td>
                                                                    {/* <td>{user.submission_time}</td> */}
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {!this.props.match.params.contestId.includes('cf') && <div className="col-11 d-flex justify-content-end PageNav">
                                                <FaChevronLeft onClick={this.prevPage} className="mt-1 mr-1 Icons"/>
                                                <p className="PageCount">
                                                    {this.state.count !== 0 ? <span className="PagePoint" onClick={this.prevPage}>{this.state.count / 25}</span> : null}
                                                    <span className="active">
                                                        {this.state.count / 25 + 1}
                                                    </span>
                                                    {
                                                        this.state.leaderboard.length !== 0 ? 
                                                        <span className="PagePoint" onClick={this.nextPage}>
                                                            {this.state.count / 25 + 2}
                                                        </span> : null
                                                    }
                                                </p>
                                                <FaChevronRight onClick={this.nextPage} className="mt-1 ml-1 Icons"/>
                                        </div>}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )
        }
        catch {
            return (
                <Redirect to="/404Page" />
            )
        }
    }
}

const mapStateToProps = state => {
    return {
        username: state.auth.username
    }
}

export default connect(mapStateToProps)(Leaderboard);

